"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  axios: true
};
Object.defineProperty(exports, "axios", {
  enumerable: true,
  get: function () {
    return _axios.default;
  }
});
var _axios = _interopRequireWildcard(require("axios"));
Object.keys(_axios).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _axios[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _axios[key];
    }
  });
});
var _createAxiosWithCache = require("./createAxiosWithCache");
Object.keys(_createAxiosWithCache).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _createAxiosWithCache[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _createAxiosWithCache[key];
    }
  });
});
var _joinPathSegments = require("./joinPathSegments");
Object.keys(_joinPathSegments).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _joinPathSegments[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _joinPathSegments[key];
    }
  });
});
var _SafeURL = require("./SafeURL");
Object.keys(_SafeURL).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _SafeURL[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SafeURL[key];
    }
  });
});
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
